import { messages as messages$1 } from '../../../messages/adminPortal/en.json.mjs';

const messages = messages$1;

export { messages };
//# sourceMappingURL=en.mjs.map
